import { render } from "./DeskTop.vue?vue&type=template&id=a09a164a&scoped=true"
import script from "./DeskTop.vue?vue&type=script&lang=js"
export * from "./DeskTop.vue?vue&type=script&lang=js"

import "./DeskTop.vue?vue&type=style&index=0&id=a09a164a&lang=css"
import "./DeskTop.vue?vue&type=style&index=1&id=a09a164a&scoped=true&lang=scss"

import exportComponent from "D:\\project\\2024\\htos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a09a164a"]])

export default __exports__